export default __webpack_public_path__ + "static/media/dinner2.d08da3bf.jpeg";